import { Button } from "antd";

import StyledContainer from "./style";

const CardThemePalette = ({
  hideActiveButton,
  isActive,
  onClick,
  themeData,
}) => (
  <StyledContainer
    className={isActive && "active"}
    onClick={() => onClick && onClick()}
    style={{ cursor: onClick && "pointer" }}
  >
    {!hideActiveButton && <Button shape="round" type="text" />}

    <div className="palette">
      {themeData.demoPalette.map((color, index) => (
        <div
          className="item"
          key={index}
          style={{
            backgroundColor: color,
            marginLeft: index !== 0 && "-12px",
            zIndex: themeData.demoPalette.length - index,
          }}
        />
      ))}
    </div>
    <span>{themeData.themeName}</span>
  </StyledContainer>
);

export default CardThemePalette;
